<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col
        :md="agent ? 8 : 12"
        cols="12"
        class="pt-1"
      >
        <v-card
          v-if="!loadingdata || $route.params.id === 'new'"
          flat
          max-width="1000"
          :class="{ 'file-sign-list-width': $vuetify.breakpoint.smAndUp }"
          class="mt-0 transparent"
        >
          <v-breadcrumbs
            v-if="agent"
            :items="breadCrumbs"
            divider="/"
            class="pl-3"
          />
          <buy-order-pass-code v-if="!agent && !buyOrderLoaded"/>
          <buyorder-authorize v-else-if="!agent && !identification"/>

          <v-card
            v-else-if="!edit"
            outlined
            class="pb-0"
          >
            <v-card-text :class="{ 'px-8 pt-5 pb-2': $vuetify.breakpoint.mdAndUp }">
              <!-- <h1 class="my-6">
                Ostotoimeksianto {{ buyOrder.ordernumber
                  ? ` #${buyOrder.ordernumber}`: '' }}
              </h1> -->
              <buy-order-summary
                ref="buyOrderSummary"
                :buy-order="buyOrder"
                :current-status="currentStatus"
              />
            </v-card-text>
            <v-card-actions
              v-if="agent || identification"
              :class="{ 'wrap' : mobile }"
              class="px-6 pt-0 pb-4"
            >
              <v-btn
                v-if="agent"
                class="my-1"
                :block="mobile"
                color="primary"
                :disabled="buyOrder.signatures && buyOrder.signatures.length > 0"
                depressed
                @click="edit = true"
              >
                Muokkaa
              </v-btn>
              <v-btn
                :block="mobile"
                class="my-1"
                color="primary"
                depressed
                @click="printPdf()"
              >
                Lataa
              </v-btn>
              <v-btn
                v-if="!agent"
                :block="mobile"
                color="primary"
                class="my-1"
                depressed
                @click="logout()"
              >
                Poistu
              </v-btn>
              <buy-order-send-links v-if="agent" :buy-order="buyOrder"/>
              <v-btn
                v-if="agent"
                color="primary"
                depressed
                class="my-1"
                :disabled="!!buyOrder.property"
                :block="mobile"
                @click="addProperty()"
              >
                Luo kohdekortti
              </v-btn>
            </v-card-actions>
            <v-alert
              v-if="!agent"
              icon="person"
              prominent
              text
              class="mt-4 mb-0"
              :color="identifiedUserHasSigned ? 'green' : 'blue'"
            >
              <v-row align="center">
                <v-col class="grow">
                  <b>{{ currentSigner.name }}</b><br>
                  {{ currentSigner.ssn }}
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pt-1' : ''" class="shrink">
                  <v-dialog
                    v-if="!identifiedUserHasSigned"
                    v-model="signDialog"
                    persistent
                    max-width="400"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="blue"
                        depressed
                        dark
                        large
                        v-on="on"
                      >
                        Allekirjoita
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h5">
                        Haluatko varmasti allekirjoittaa?
                      </v-card-title>
                      <v-card-text class="pt-3">
                        {{ currentSigner.name }}!<br>
                        Olet allekirjoittamassa sähköisen ostotoimeksiannon,
                        ja sitoudut siinä määriteltyihin ehtoihin. Täydennäthän / korjaathan
                        yhteystietosi, mikäli niissä on puutteita.
                        <v-text-field
                          v-model="currentSignerDetails.phone"
                          class="mt-4"
                          autocomplete="off"
                          outlined
                          label="Puhelinnumero"
                        />
                        <v-text-field
                          v-model="currentSignerDetails.address"
                          autocomplete="off"
                          outlined
                          label="Osoite"
                        />
                        <v-text-field
                          v-model="currentSignerDetails.zip"
                          autocomplete="off"
                          outlined
                          label="Postinumero"
                        />
                        <v-text-field
                          v-model="currentSignerDetails.city"
                          autocomplete="off"
                          outlined
                          label="Kaupunki"
                        />
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer/>
                        <v-btn text @click="signDialog = false">
                          Peruuta
                        </v-btn>
                        <v-btn
                          color="primary"
                          text
                          :disabled="currentSignerDetailsMissing"
                          @click="sign()"
                        >
                          Allekirjoita
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <span v-else>Allekirjoitettu</span>
                </v-col>
              </v-row>
            </v-alert>
          </v-card>
          <v-card v-else outlined>
            <div class="helmi-card-title pt-4 pl-4">
              Ostotoimeksianto {{ buyOrder.ordernumber
                ? ` #${buyOrder.ordernumber}`: '' }}
            </div>
            <v-card-text :class="{ 'px-8 pt-0': $vuetify.breakpoint.mdAndUp }">
              <span
                :style="`
                  background-color: #fff;
                  margin-left:10px;
                  padding: 4px;
                  position:relative;
                  z-index: 1;
                  font-size: 12px;
                `"
              >
                Toimeksiantajat
              </span>
              <v-card outlined style="margin-top: -12px;">
                <v-list
                  class="mb-0 pb-0"
                  two-line
                  outlined
                  dense
                  subheader
                >
                  <v-alert
                    v-if="buyOrder.persons && !buyOrder.persons.length"
                    type="warning"
                    dense
                    text
                    class="ma-4"
                  >
                    Ei toimeksiantajia!
                  </v-alert>
                  <template
                    v-for="(item, s) in buyOrder.persons"
                  >
                    <v-list-item
                      :key="`${s}-A`"
                      :class="{ 'px-6': $vuetify.breakpoint.mdAndUp }"
                    >
                      <v-list-item-avatar
                        class="mr-4"
                        :size="$vuetify.breakpoint.mdAndUp ? 40 : 30"
                      >
                        <v-icon
                          :class="item.person_role === 'signer' ? 'orange' : 'blue'"
                          class="white--text"
                          :size="$vuetify.breakpoint.mdAndUp ? 24 : 20"
                        >
                          person
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content class="py-0">
                        <v-list-item-title class="primary--text">
                          {{ item.name }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ item.email }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-avatar class="my-0">
                        <v-menu
                          offset-y
                          max-width="290"
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                              icon
                              v-on="on"
                            >
                              <v-icon>
                                more_vert
                              </v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item @click="editPerson(item)">
                              <v-list-item-title>Muokkaa</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="removePersonFromBuyOrder(item)">
                              <v-list-item-title>Poista</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-list-item-avatar>
                    </v-list-item>
                    <v-divider v-if="s < buyOrder.persons.length - 1" :key="`${s}-B`"/>
                  </template>
                </v-list>
              </v-card>

              <v-dialog
                v-model="dialog"
                :fullscreen="$vuetify.breakpoint.smAndDown"
                width="550"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="primary"
                    depressed
                    class="mb-5 mt-2"
                    v-on="on"
                    @click="resetForm()"
                  >
                    Lisää
                    <v-icon right dark>
                      person_add
                    </v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="text-h5">
                    {{ (newPerson.id && showForm) ? 'Muokkaa henkilötietoja' : 'Lisää henkilö' }}
                  </v-card-title>
                  <v-card-text v-if="!showForm" class="pa-4">
                    <v-autocomplete
                      v-model="selectedPersonId"
                      :loading="loading"
                      :items="customers"
                      :search-input.sync="search"
                      item-text="name"
                      item-value="id"
                      autocomplete="off"
                      label="Hae"
                      prepend-inner-icon="search"
                      hide-details
                      outlined
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title v-if="!search || (search && search.length < 3)">
                            Syötä vähintään
                            <strong>3</strong>
                            kirjainta.
                          </v-list-item-title>
                          <v-list-item-title v-else>
                            Ei hakutuloksia
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                      <template v-slot:selection="data">
                        <v-chip
                          v-if="selectedPersonId"
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          @click="data.select"
                        >
                          <v-avatar left>
                            <v-icon>person</v-icon>
                          </v-avatar>
                          {{ data.item.name }}
                          {{ data.item.ssn }}
                        </v-chip>
                      </template>
                      <template v-slot:item="data">
                        <template>
                          <v-list-item-avatar>
                            <v-icon>person</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-text="data.item.name"/>
                            <v-list-item-subtitle v-text="data.item.ssn"/>
                          </v-list-item-content>
                        </template>
                      </template>
                      <template v-slot:append-item>
                        <v-list color="primary--text" rounded>
                          <v-list-item @click="showForm = true">
                            <v-list-item-avatar>
                              <v-icon>person_add</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title>Lisää uusi</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </template>
                    </v-autocomplete>
                  </v-card-text>
                  <buy-order-person-form
                    v-if="showForm"
                    :people="buyOrder.persons"
                    :selected-person-id="selectedPersonId"
                    :new-person="newPerson"
                  />
                  <v-card-actions v-if="!showForm" class="px-4 pb-4">
                    <v-spacer/>
                    <v-btn
                      text
                      @click="dialog = false"
                    >
                      Peruuta
                    </v-btn>
                    <v-btn
                      color="primary"
                      :disabled="!selectedPersonId"
                      text
                      :loading="addingPerson"
                      @click="addPersonToBuyOrder()"
                    >
                      Lisää
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-text>
            <v-divider/>
            <v-card-text :class="{ 'px-8 pt-5 pb-8': $vuetify.breakpoint.mdAndUp }">
              <h2 class="mt-4 mb-4">
                Ostotoimeksiannon perustiedot
              </h2>
              <p class="mb-0">
                Ostotoimeksiannon tyyppi- ja maakuntatieto, sekä julkinen kuvaus ovat julkisia
                tietoja, jotka voidaan näyttää portaaleissa tai omilla verkkosivuilla.
              </p>
              <v-row>
                <v-col>
                  <v-select
                    v-model="buyOrder.property_type"
                    class="mt-4"
                    :items="propertyTypesArray"
                    label="Haluttu kohdetyyppi"
                    multiple
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col>
                  <v-select
                    v-model="buyOrder.agent"
                    class="mt-4"
                    :items="agents"
                    item-text="nimi"
                    item-value="id"
                    label="Hoitaja"
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col>
                  <v-select
                    v-model="buyOrder.status"
                    class="mt-4"
                    :items="statuses"
                    label="Toimeksiannon tila"
                    hide-details
                    outlined
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0">
                  <v-select
                    v-model="buyOrder.region"
                    :items="regions"
                    label="Maakunta"
                    outlined
                    :rules="[regionFromList]"
                  />
                </v-col>
              </v-row>

              <v-textarea
                v-model="buyOrder.description"
                label="Toimeksiannon kuvaus (julkinen)"
                class="mt-0 mb-0"
                auto-grow
                hide-details
                outlined
                rows="8"
              />
            </v-card-text>
            <v-divider/>
            <v-card-text :class="{ 'px-8 pt-8': $vuetify.breakpoint.mdAndUp }">
              <h2 class="mb-5">
                Toimeksiantosopimuksen tiedot
              </h2>

              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="buyOrder.fields.lengthPeriod"
                    :items="lengthPeriods"
                    label="Voimassaolo"
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  class="pb-0"
                >
                  <v-menu
                    v-model="createdMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="buyOrderCreatedFormatted"
                        outlined
                        label="Toimeksiannon alku"
                        append-icon="event"
                        hide-details
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="buyOrder.created"
                      first-day-of-week="1"
                      locale="fi-FI"
                      hide-details
                      @input="createdMenu = false"
                    />
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  class="pb-0"
                >
                  <v-menu
                    v-if="buyOrder.fields && buyOrder.fields.lengthPeriod !== 1"
                    v-model="endsMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="buyOrderEndsFormatted"
                        outlined
                        label="Toimeksiannon loppu"
                        append-icon="event"
                        hide-details
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="buyOrder.ends"
                      first-day-of-week="1"
                      locale="fi-FI"
                      hide-details
                      @input="endsMenu = false"
                    />
                  </v-menu>
                  <v-text-field
                    v-else
                    v-model="buyOrder.fields.forNow"
                    autocomplete="off"
                    hide-details
                    outlined
                    label="Jakson pituus"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  class="pb-0"
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="buyOrder.brokerage"
                    autocomplete="off"
                    hide-details
                    outlined
                    type="number"
                    label="Välityspalkkio (kiinteä)"
                  />
                </v-col>
                <v-col
                  class="pb-0"
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="buyOrder.fields.brokeragePercent"
                    autocomplete="off"
                    hide-details
                    outlined
                    type="number"
                    label="Välityspalkkio (prosentti)"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    v-model="buyOrder.fields.comissionBasis"
                    class="mt-4"
                    :items="comissionBasisItems"
                    label="Välityspalkkion peruste"
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col>
                  <v-select
                    v-model="buyOrder.fields.exclusive"
                    class="mt-4"
                    :items="exclusiveItems"
                    label="Toimeksiannon yksinoikeus"
                    hide-details
                    outlined
                  />
                </v-col>
              </v-row>
              <v-text-field
                v-model="buyOrder.fields.condition"
                class="mt-3 mb-0"
                autocomplete="off"
                hide-details
                outlined
                label="Kohteen kunto"
              />
              <v-text-field
                v-model="buyOrder.fields.size"
                class="mt-3 mb-0"
                autocomplete="off"
                hide-details
                outlined
                label="Kohteen koko"
              />
              <v-text-field
                v-model="buyOrder.fields.equipment"
                class="mt-3 mb-0"
                autocomplete="off"
                hide-details
                outlined
                label="Kohteen varustetaso"
              />
              <v-text-field
                v-model="buyOrder.fields.vacancy"
                class="mt-3 mb-0"
                autocomplete="off"
                hide-details
                outlined
                label="Kohteen vapautuminen"
              />
              <v-text-field
                v-model="buyOrder.fields.paymentTerms"
                class="mt-3 mb-0"
                autocomplete="off"
                hide-details
                outlined
                label="Maksuehdot"
              />
              <v-textarea
                v-model="buyOrder.fields.conditions"
                label="Kohteen muut ehdot ja erityistoiveet"
                class="mt-3 mb-0"
                auto-grow
                hide-details
                outlined
                rows="4"
              />
              <v-text-field
                v-model="buyOrder.fields.rooms"
                class="mt-3 mb-0"
                autocomplete="off"
                hide-details
                outlined
                label="Kohteen huonelukumäärä"
              />
              <div class="mt-4"/>
              <v-text-field
                v-model="buyOrder.fields.price"
                class="mt-3 mb-0"
                autocomplete="off"
                hide-details
                outlined
                label="Kohteen hinta"
              />
              <div>&nbsp;</div>
              <v-text-field
                v-model="buyOrder.fields.brokerageOther"
                class="mt-5"
                autocomplete="off"
                hide-details
                outlined
                label="Muu palkkioperuste, toimeksiantajalle aiheutuvat muut
                kustannukset ja vähimmäispalkkio"
              />
              <v-text-field
                v-model="buyOrder.fields.brokerageOtherFee"
                class="mt-4"
                autocomplete="off"
                hide-details
                outlined
                label="Jos toimeksiantaja ei ole velvollinen maksamaan välityspalkkiota,
                toimeksiantaja suorittaa välitysliikkeelle kuitenkin seuraavat korvaukset"
              />
              <v-checkbox
                v-model="buyOrder.fields.condition1"
                dense
                hide-details
                label="Toimeksiantaja on sitoutunut
                  toimeksiantosopimuksen ehtoihin vasta välitysliikkeen
                  toimitiloissa (ei kotimyyntitilanne)"
              />
              <v-checkbox
                v-model="buyOrder.fields.condition2"
                dense
                hide-details
                label="Toimeksiantaja on sitoutunut toimeksiantosopimuksen
                  ehtoihin muualla kuin välitysliikkeen toimitiloissa"
              />
              <v-checkbox
                v-model="buyOrder.fields.condition3"
                dense
                hide-details
                label="Toimeksiantaja kuittaa vastaanottaneensa erillisen
                  peruuttamislomakkeen ja peruuttamisohjeen"
              />
              <v-checkbox
                v-model="buyOrder.fields.condition4"
                dense
                hide-details
                label="Toimeksiantaja pyytää, että välitysliike aloittaa
                  toimeksiannon suorittamisen ennen kuin peruuttamisaika on päättynyt"
              />
              <v-checkbox
                v-model="buyOrder.fields.condition5"
                dense
                hide-details
                label="Annan suostumukseni sille, että toteutuneen kaupan tiedot
                  julkistetaan ympäristöministeriön asuntojen.hintatiedot.fi -palvelussa"
              />
              <v-textarea
                v-model="buyOrder.fields.otherConditions"
                label="Toimeksiannon muut ehdot"
                class="mt-3 mb-0"
                auto-grow
                hide-details
                outlined
                rows="4"
              />
              <v-checkbox
                v-model="buyOrder.fields.dataProtection1"
                dense
                hide-details
                label="Asiakasta on ohjattu tutustumaan etukäteen tietosuojaselosteeseen."
              />
              <v-checkbox
                v-model="buyOrder.fields.dataProtection2"
                dense
                hide-details
                label="Kaupan tietoja luovutetaan Kiinteistönvälitysalan Keskusliitto
                (KVKL) ry:lle, jossa tiedot tallennetaan KVKL:n hintaseurantapalveluun
                (HSP), jonka tietosuojaseloste on saatavilla osoitteesta
                www.hintaseurantapalvelu.fi/tietosuoja. Lisäksi pyydämme suostumustanne
                alla selostettuja tarkoituksia varten. Annatte suostumuksenne lisäämällä
                rastin ruutuun. Teillä on oikeus peruuttaa suostumus milloin tahansa
                ilmoittamalla peruuttamisesta kirjallisesti tai sähköpostitse välitysliikkeelle."
              />
              <v-checkbox
                v-model="buyOrder.fields.dataProtection3"
                dense
                hide-details
                label="Annan suostumukseni siihen, että välitysliike saa lähettää minulle sähköistä
                suoramarkkinointia (esim. tekstiviesti, sähköposti)."
              />
              <v-checkbox
                v-model="buyOrder.fields.dataProtection4"
                dense
                hide-details
                label="Annan suostumukseni siihen, että välitysliike lähettää minulle, kaupan
                  toiselle osapuolelle, isännöitsijälle, asiaan osalliselle pankille ja/tai
                  viranomaiselle sähköpostitse henkilötunnukseni sisältäviä asiakirjoja.
                  Henkilötunnuksen jakaminen näiden tahojen kanssa on välttämätöntä tunnistamisen
                  varmistamiseksi."
              />
              <v-checkbox
                v-model="buyOrder.fields.dataProtection5"
                dense
                hide-details
                label="Olen tietoinen siitä, että sähköpostia ei lähetetä suojatussa yhteydessä
                  eikä salattuna."
              />
              <v-select
                v-model="buyOrder.fields.pep"
                class="mt-4"
                label="Poliittinen vaikutusvalta"
                :items="pepItems"
                hint="Oletko tai oletko ollut viimeisen vuoden aikana poliittisesti
                  vaikutusvaltainen henkilö (PEP) tai sellaisen henkilön perheenjäsen
                  tai läheinen yhtiökumppani?"
                persistent-hint
                outlined
              />
              <v-textarea
                v-if="buyOrder.fields.pep === 0"
                v-model="buyOrder.fields.pepMoreInfo"
                label="Lisätietoja (PEP)"
                class="mt-3 mb-0"
                auto-grow
                hide-details
                outlined
                rows="3"
              />
            </v-card-text>

            <v-container class="mx-5 py-0">
              <v-checkbox
                v-model="includeCancel"
                label="Sisällytä etämyynnin peruuttamislomake"
              />
            </v-container>

            <canceling
              v-if="includeCancel"
              :canceling="cancelSchema"
              class="mx-6"
            />

            <v-card-actions class="px-8 pb-4">
              <v-spacer/>
              <v-btn
                color="primary"
                class="mb-2"
                outlined
                @click="edit = false"
              >
                Peruuta
              </v-btn>
              <v-btn
                color="primary"
                class="mb-2"
                depressed
                :loading="savingBuyOrder"
                @click="saveBuyOrder()"
              >
                Tallenna
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card>
      </v-col>
      <v-col
        v-if="agent"
        cols="12"
        md="4"
      >
        <buy-order-log v-if="agent" :log-items="logItems"/>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="messageBox"
      :color="messageColor"
    >
      {{ message }}
    </v-snackbar>
  </v-container>
</template>
<script>
import moment from 'moment';
import _ from 'lodash';
import { mapGetters, mapState, mapActions } from 'vuex';
import { apiGet, apiPost } from '../api';

const buyOrder = {
  created: new Date().toISOString().substr(0, 10),
  ends: null,
  agent: null,
  description: '',
  region: '',
  brokerage: '',
  canceling: {
    selectedAgent: {},
  },
  fields: {
    condition: '',
    rooms: '',
    equipment: '',
    size: '',
    price: '',
    vacancy: '',
    brokeragePercent: '',
    conditions: '',
    paymentTerms: '',
    lengthPeriod: 0,
    forNow: '',
    comissionBasis: 0,
    exclusive: 0,
    condition3: true,
    condition4: true,
    condition5: true,
    dataProtection1: true,
    dataProtection2: true,
    dataProtection3: true,
    dataProtection4: true,
    dataProtection5: true,
  },
  property_type: [0],
  status: 3,
  persons: [],
};

export default {
  components: {
    'buy-order-person-form': () => import('@/components/BuyOrderPersonForm'),
    'buy-order-summary': () => import('@/components/BuyOrderSummary'),
    'buyorder-authorize': () => import('@/components/BuyOrderAuthorize'),
    'buy-order-send-links': () => import('@/components/BuyOrderSendLinks'),
    'buy-order-pass-code': () => import('@/components/BuyOrderPassCode'),
    'buy-order-log': () => import('@/components/BuyOrderLog'),
    canceling: () => import('@/components/commissionAgreement/Canceling'),
  },
  data: () => ({
    includeCancel: true,
    cancelSchema: {},
    signDialog: false,
    edit: false,
    loadingdata: true,
    buyOrderLoaded: false,
    messageBox: false,
    messageColor: 'green',
    message: '',
    createdMenu: false,
    endsMenu: false,
    addingPerson: false,
    savingBuyOrder: false,
    dialog: false,
    showForm: false,
    regions: [
      'Uusimaa',
      'Varsinais-Suomi',
      'Satakunta',
      'Kanta-Häme',
      'Pirkanmaa',
      'Päijät-Häme',
      'Kymenlaakso',
      'Etelä-Karjala',
      'Etelä-Savo',
      'Pohjois-Savo',
      'Pohjois-Karjala',
      'Keski-Suomi',
      'Etelä-Pohjanmaa',
      'Pohjanmaa',
      'Keski-Pohjanmaa',
      'Pohjois-Pohjanmaa',
      'Kainuu',
      'Lappi',
      'Ahvenanmaa',
    ],
    buyOrder,
    currentStatus: null,
    selectedPersonId: null,
    loading: false,
    customers: [],
    select: null,
    logItems: [],
    search: '',
    agents: [],
    newPerson: {
      id: null,
      isCompany: false,
      companyName: '',
      companyNumber: '',
      name: '',
      phone: '',
      address: '',
      email: '',
      ssn: '',
      nationality: 'Suomi',
    },
    lengthPeriods: [{
      value: 0,
      text: 'Määräaikainen',
    }, {
      value: 1,
      text: 'Toistaiseksi',
    }],
    comissionBasisItems: [{
      value: 0,
      text: 'Velaton kauppahinta',
    }, {
      value: 1,
      text: 'Kauppahinta',
    }],
    exclusiveItems: [{
      value: 0,
      text: 'Yksinoikeudella',
    }, {
      value: 1,
      text: 'Ei yksinoikeudella',
    }],
    pepItems: [{
      value: 0,
      text: 'Kyllä',
    }, {
      value: 1,
      text: 'Ei',
    }],
    statuses: [{
      value: 3,
      text: 'Luonnos',
    }, {
      value: 1,
      text: 'Aktiivinen',
    }, {
      value: 2,
      text: 'Toteutunut',
    }, {
      value: 0,
      text: 'Päätetty',
    }],
    propertyTypesArray: [
      {
        value: 0,
        text: 'Omakotitalo',
      },
      {
        value: 1,
        text: 'Rivitalo',
      },
      {
        value: 2,
        text: 'Kerrostalo',
      },
      {
        value: 3,
        text: 'Loma-asunto',
      },
      {
        value: 4,
        text: 'Tontti',
      },
      {
        value: 5,
        text: 'Liiketila',
      },
      {
        value: 6,
        text: 'Autotalli',
      },
      {
        value: 7,
        text: 'Varasto',
      },
      {
        value: 8,
        text: 'Paritalo',
      },
      {
        value: 9,
        text: 'Erillistalo',
      },
      {
        value: 10,
        text: 'Lomahuoneisto',
      },
      {
        value: 11,
        text: 'Loma-asunto ulkomailla',
      },
      {
        value: 12,
        text: 'Loma-osake',
      },
      {
        value: 13,
        text: 'Omakotitalotontti',
      },
      {
        value: 14,
        text: 'Vapaa-ajan tontti',
      },
      {
        value: 15,
        text: 'Rivitalotontti',
      },
      {
        value: 16,
        text: 'Autopaikka',
      },
      {
        value: 17,
        text: 'Maatila',
      },
      {
        value: 18,
        text: 'Metsätila',
      },
      {
        value: 19,
        text: 'Toimistotila',
      },
      {
        value: 20,
        text: 'Tuotantotila',
      },
      {
        value: 21,
        text: 'Puutalo-osake',
      },
      {
        value: 22,
        text: 'Luhtitalo',
      },
      {
        value: 23,
        text: 'Muu toimitila',
      },
      {
        value: 24,
        text: 'Muu',
      },
    ],
  }),
  computed: {
    ...mapState({
      agent: state => state.agent,
      identification: state => state.identification,
      currentSigner: state => state.currentSigner,
    }),
    ...mapGetters({
      userDetails: 'userDetails',
    }),
    mobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    identifiedUser() {
      return this.buyOrder.identifiedUser || {};
    },
    identifiedUserHasSigned() {
      return this.buyOrder.signatures
        && this.buyOrder.signatures.some(i => i.ssn === this.currentSigner.ssn);
    },
    currentSignerDetails() {
      return this.buyOrder.persons.find(i => i.id === this.currentSigner.person_id) || {};
    },
    currentSignerDetailsMissing() {
      if (!this.currentSignerDetails) return true;
      const fields = ['phone', 'address', 'zip', 'city'];
      return fields.some(i => !this.currentSignerDetails[i]);
    },
    regionFromList() {
      return this.regions.some(r => r === this.buyOrder.region) || 'Valitse maakunta';
    },
    breadCrumbs() {
      return [
        {
          disabled: false,
          href: `/public/app/${this.$route.params.companyId}/buyorders/`,
          link: true,
          text: 'Ostotoimeksiannot',
        }, {
          disabled: false,
          link: false,
          text: (this.buyOrder && this.buyOrder.ordernumber) ? `Ostotoimeksianto #${this.buyOrder.ordernumber}` : 'Uusi ostotoimeksianto',
        }];
    },
    buyOrderCreatedFormatted() {
      if (this.buyOrder.created) return this.formatDate(this.buyOrder.created, false);
      return '';
    },
    buyOrderEndsFormatted() {
      if (this.buyOrder.ends) return this.formatDate(this.buyOrder.ends, false);
      return '';
    },
  },
  watch: {
    search(val) {
      if (val && val !== this.select) this.querySelections(val);
    },
    selectedPersonId: {
      async handler() {
        if (this.selectedPersonId !== '') {
          this.newPerson = {
            ..._.cloneDeep(this.customers.find(c => c.id === this.selectedPersonId)),
          };
        }
      },
      deep: true,
    },
  },
  created() {
    this.resetCurrentProperty();
    this.getIdentification();
    this.$bus.$emit('SHOW_GLOBAL_LOADER', 'Ladataan tietoja');
    this.$bus.$on('RELOAD_BUY_ORDER', () => {
      this.getBuyOrder();
    });
    if (this.buyOrder.ends === null) {
      const now = new Date();
      this.buyOrder.ends = new Date(moment(now).add(4, 'months'))
        .toISOString().substr(0, 10);
    }
    this.$bus.$on('closePersonDialog', async () => {
      this.showForm = false;
      this.dialog = false;
    });
    // this.$bus.$on('updateOrder', async () => {
    //   this.getBuyOrder();
    // });
    this.$bus.$on('showSnackbar', (params) => {
      this.messageColor = params.color;
      this.message = params.message;
      this.messageBox = true;
    });
  },
  async mounted() {
    const promises = [
      import('@/components/commissionAgreement/data/cancel.js'),
    ];
    let cancelSchema = null;
    [
      { default: cancelSchema },
    ] = await Promise.all(promises);
    this.cancelSchema = _.cloneDeep(cancelSchema);

    if (this.$route.params.id === 'new') {
      this.edit = true;
      const agentResponse = await apiGet('agent/getAgents');
      this.agents = agentResponse.result;
      this.buyOrder.agent = this.agents.find(a => a.nimi === this.userDetails.nimi).id;
      this.$bus.$emit('HIDE_GLOBAL_LOADER');
    } else {
      this.getBuyOrder();
    }
  },
  methods: {
    ...mapActions({
      resetCurrentProperty: 'resetCurrentProperty',
      getIdentification: 'getIdentification',
    }),
    addProperty() {
      const url = `${this.userDetails.rootpath}/avaa.php?buyorder=${this.$route.params.id}`;
      window.location.href = url;
    },
    async sign() {
      this.signDialog = false;
      await apiPost('buyorders/sign', {
        address: this.currentSignerDetails.address,
        zip: this.currentSignerDetails.zip,
        city: this.currentSignerDetails.city,
        phone: this.currentSignerDetails.phone,
      });
      await this.getBuyOrder();
    },
    async logout() {
      await apiGet('authorization/logout');
      await this.getIdentification();
      await this.getBuyOrder();
      this.buyOrder = buyOrder;
      this.loadingdata = true;
      this.buyOrderLoaded = false;
    },
    printPdf() {
      this.$refs.buyOrderSummary.printPdf();
    },
    editPerson(person) {
      this.newPerson = _.cloneDeep(person);
      this.showForm = true;
      this.dialog = true;
    },
    validateEmail(email) {
      const validEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return email.match(validEmail);
    },
    validateSsn(ssn) {
      const validssn = /^(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])([5-9]\d\+|\d\d-|[01]\dA)\d{3}[\dABCDEFHJKLMNPRSTUVWXY]$/;
      return ssn.match(validssn);
    },
    async querySelections(payload) {
      if (payload === '') return;
      if (payload.length < 3) return;
      this.loading = true;
      this.fetchEntriesDebounced(payload);
    },
    addPersonToBuyOrder() {
      if (!this.buyOrder.persons.some(e => e.id === this.newPerson.id)) {
        this.buyOrder.persons.push(_.cloneDeep(this.newPerson));
        this.messageColor = 'green';
        this.message = 'Henkilö lisätty';
        this.messageBox = true;
      }
      this.dialog = false;
    },
    removePersonFromBuyOrder(person) {
      this.buyOrder.persons = this.buyOrder.persons.filter(e => e.id !== person.id);
    },
    fetchEntriesDebounced(payload) {
      // cancel pending call
      clearTimeout(this._timerId);
      const that = this;
      // delay new call 500ms
      this._timerId = setTimeout(async () => {
        const response = await apiPost('customer/search', { query: payload });
        that.customers = response.result;
        that.loading = false;
      }, 500);
    },
    async getBuyOrder() {
      const agentResponse = await apiGet('agent/getAgents');
      this.agents = agentResponse.result;
      const response = await apiGet(`buyorders/get/${this.$route.params.id}`);
      if (response && response.result) {
        this.buyOrder = {
          ...response.result,
          fields: response.result.fields ? JSON.parse(response.result.fields) : {},
          // property_type: parseInt(response.result.property_type, 10),
          property_type: response.result.property_type.split(',').map(i => parseInt(i, 10)),
          status: parseInt(response.result.status, 10),
          created: new Date(response.result.created.replace(' 00:00:00', '')).toISOString().substr(0, 10),
          ends: new Date(response.result.ends.replace(' 00:00:00', '')).toISOString().substr(0, 10),
        };
        if (this.buyOrder.fields.canceling) {
          this.includeCancel = true;
        }
        this.currentStatus = response.result.status;
        if (this.agent) {
          const logresponse = await apiGet(`buyorders/log/${this.$route.params.id}`);
          this.logItems = logresponse.result;
        }
        this.buyOrderLoaded = true;
      }
      setTimeout(() => {
        this.loadingdata = false;
        this.$bus.$emit('HIDE_GLOBAL_LOADER');
      }, 1000);
    },
    async saveBuyOrder() {
      if (this.includeCancel) {
        this.buyOrder.fields.canceling = _.cloneDeep(this.cancelSchema);
      } else {
        this.buyOrder.fields.canceling = null;
      }
      this.savingBuyOrder = true;
      const params = _.cloneDeep(this.buyOrder);
      params.property_type = params.property_type.join(',');
      if (params.id) {
        params.previousStatus = this.currentStatus;
      }
      const response = await apiPost('buyorders/save', params);
      this.savingBuyOrder = false;
      if (!params.id) {
        this.$router.push(`/${this.$route.params.companyId}/buyorders/${response.id}`);
      }
      this.$bus.$emit('SHOW_GLOBAL_LOADER', 'Tallennetaan');
      this.getBuyOrder();
      this.edit = false;
    },
    resetForm() {
      this.showForm = false;
      this.newPerson.name = '';
      this.newPerson.phone = '';
      this.newPerson.address = '';
      this.newPerson.zip = '';
      this.newPerson.city = '';
      this.newPerson.email = '';
      this.newPerson.ssn = '';
      this.newPerson.id = null;
      this.selectedPersonId = '';
    },
    formatDate(date, time = true) {
      if (!date) return null;
      if (time === false) return moment(date).format('DD.MM.YYYY');
      return moment(date).format('DD.MM.YYYY HH:mm');
    },
  },
};
</script>
<style lang="scss" scoped>
  .wrap {
    flex-wrap: wrap !important;

    button {
      margin-left: 0 !important;
    }
  }
</style>
